import Vue from 'vue';
import 'bootstrap';
import VueCookies from 'vue-cookies';
import VueTimeago from 'vue-timeago';
import { Plugin } from 'vue-fragment';
import VueScrollTo from 'vue-scrollto';
import $ from 'jquery';
import Swal from 'sweetalert2';
import VueBus from 'vue-bus';
import FastClick from 'fastclick';
import CKEditor from '@ckeditor/ckeditor5-vue2';
// import '@handl-web/ckeditor';

import SharedComponents from '@handl-web/shared-components';

import App from './App.vue';
import { trackingVendor } from '@/global/fingerPrint';
import router from './global/router';
import store from './global/store';
import { setLocalStorageItem } from './global/storage';
import {
  isBrowserSupported,
  getFullUrl,
  getUserAgent,
  getReferrer,
  getReferrerHost,
  isEntryPage,
} from '@/utils/browser';
import { cookieGetItem, cookieSetItemInfinity, cookieRemoveItem } from '@/global/cookie';
import { LOGIN_PAGE, LOGIN_PHONE_PAGE, DASHBOARD_PAGE, IDENTITY_PAGE } from '@/constants/routes';
import {
  LOGIN_PAGE_CHUNK_NAME,
  PAGE_ACCESS_MAP,
  BROWSER_SUPPORTED_TEXT,
  BROWSER_SUPPORTED_TITLE,
  SET_IS_DEBUG,
  LOGIN_PHONE_PAGE_CHUNK_NAME,
  LANDING_PAGE_CHUNK_NAME,
  REDIRECT_URLS,
  HTTPS_URL_WWW_PZ_ACADEMY_COM,
} from '@/constants';

import '@handl-web/pz-ui/css/class-v2.css';

Vue.config.productionTip = false;
Vue.use(SharedComponents);
Vue.use(VueBus);
Vue.use(Plugin);
Vue.use(VueCookies);
Vue.use(CKEditor);
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'zh',
  locales: {
    'zh-CN': require('date-fns/locale/zh_cn'),
  },
});

const getVendorId = (route) => {
  let vendorId = route.query.vendorid || cookieGetItem('vendorId');
  if (vendorId) {
    vendorId = parseInt(vendorId);
  }
  return vendorId;
};

const sendEventTracker = async (route, store) => {
  const res = await store.dispatch('eventTracker', {
    visitorMap: {
      fromDomain: getReferrerHost(),
      fromEngine: '',
      fromKeyword: '',
      fromType: '',
      fromUrl: getReferrer(),
      isEntrance: isEntryPage(),
      isExit: '',
      targetPath: route.path,
      targetUrl: getFullUrl(),
      vendorId: getVendorId(route),
      visitorAgent: getUserAgent(),
      visitorBrowser: '',
      visitorDeviceId: '',
      visitorId: cookieGetItem('visitor_id'),
      visitorIp: '',
      visitorIsNew: cookieGetItem('is_new_visitor'),
      visitorOs: '',
      visitorStayTime: '',
      visitorStudentId: store.state.userInfo.studentId,
    },
  });
  //cookieRemoveItem('vendorId')
  return res;
};

const sendtrackingVendor = async (route, store) => {
  const res = await trackingVendor(
    getVendorId(route),
    window.location.href,
    store.state.userInfo.studentId
  );
  cookieRemoveItem('vendorId');
  return res;
};

router.beforeEach(async (to, from, next) => {
  window._hmt.push(['_trackEvent', 'router', 'change', `from:${from.name} - to:${to.name}`, 1]);
  $('body').removeClass();
  $('body').addClass(to.name);
  if (!isBrowserSupported()) {
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: BROWSER_SUPPORTED_TEXT,
      title: BROWSER_SUPPORTED_TITLE,
      showConfirmButton: true,
      timer: 3000,
    }).then(() => {
      window.location.href = HTTPS_URL_WWW_PZ_ACADEMY_COM;
    });
    return;
  }

  if ('true' === window.sessionStorage.getItem('ispagestatic')) {
    return;
  }
  if ('true' === to.query.ispagestatic) {
    window.sessionStorage.setItem('ispagestatic', 'true');
  }

  if (to.query.fromwechat) {
    window.sessionStorage.setItem('fromwechat', to.query.fromwechat);
  }

  if ('true' === to.query.pztest) {
    window.sessionStorage.setItem('pztest', to.query.pztest);
    store.commit('SET_PZ_TEST', true);
  }
  if (to.query.isPzTest) {
    store.commit('SET_IS_DEBUG', true);
  }

  $(function () {
    $('[data-toggle="popover"]').popover('hide');
  });

  $('.modal.show').modal('hide');
  //$('.modal-backdrop.show').remove();

  if (Swal.isVisible()) {
    Swal.close();
  }

  //const noAuth =
  //  Boolean(store.state.userInfo.authenticated === -1) && Boolean(store.state.userInfo.hasPay);
  const hasLogin = Boolean(store.state.userInfo.studentId);
  const isPhoneValid =
    Boolean(store.state.userInfo.studentId) &&
    store.state.userInfo.profile &&
    store.state.userInfo.profile.mobileValided;

  if (!PAGE_ACCESS_MAP[to.name]) {
    next({ path: '/dashboard' });
    return;
  }

  if (LANDING_PAGE_CHUNK_NAME === PAGE_ACCESS_MAP[to.name]) {
    window.location.href = REDIRECT_URLS.LANDING_PAGE;
    return;
  }

  if (hasLogin && from.fullPath === to.query.login_redirect_uri) {
    const back_url = window.sessionStorage.getItem('back_url');
    if (back_url) {
      next({
        path: decodeURIComponent(back_url),
      });
      window.sessionStorage.removeItem('back_url');
    } else {
      window.location.href = REDIRECT_URLS.LANDING_PAGE;
    }
    return;
  }

  if (PAGE_ACCESS_MAP[to.name].access.needsLogin) {
    if (hasLogin) {
      if (!store.state.isHaveGotUserInfo && !PAGE_ACCESS_MAP[to.name].isFetchUserInfo) {
        store.dispatch('getUserInfo');
      }
      if (!PAGE_ACCESS_MAP[to.name].access.needsPhone || isPhoneValid) {
        if (PAGE_ACCESS_MAP[to.name].access.needsAuth) {
          await store.dispatch('getNeedIdCheck', {
            courseId: to.params.courseId,
          });
          //if (!noAuth) {
          if (store.getters.res_getNeedIdCheck > 0) {
            if (store.state.isDebug) {
              await store.dispatch('Agreement/getAgreementCheck', {
                courseId: to.params.courseId,
              });
              if (
                store.state.Agreement.res_getAgreementCheck &&
                store.state.Agreement.res_getAgreementCheck.needSignAgreement
              ) {
                const urlAgreement = `https://msite.pzacademy.com/agreement/course/${to.params.courseId}`;
                const urlParams = `?agreement_redirect_uri=${encodeURIComponent(
                  `https://class.pzacademy.com${to.fullPath}`
                )}`;
                window.location.href = `${urlAgreement}${urlParams}`;
              }
            }
            next();
          } else {
            let title = '';
            if (-1 === store.getters.res_getNeedIdCheck) {
              title = '您的认证审核失败';
            }
            if (0 === store.getters.res_getNeedIdCheck) {
              title = '您还没有认证';
            }
            Swal.fire({
              icon: 'info',
              title,
              text: '亲爱的学员请先完成认证',
              confirmButtonColor: '#3085d6',
              confirmButtonText: '去认证',
            }).then((result) => {
              if (result.value) {
                next({
                  path: `${IDENTITY_PAGE}?identity_redirect_uri=${encodeURIComponent(to.fullPath)}`,
                });
              }
            });
          }
        } else {
          next();
        }
      } else {
        next({
          path: LOGIN_PHONE_PAGE + '?login_redirect_uri=' + encodeURIComponent(to.fullPath),
        });
      }
    } else {
      let loginPath = LOGIN_PAGE;
      if (LOGIN_PHONE_PAGE_CHUNK_NAME === to.name) {
        loginPath += encodeURIComponent(to.fullPath.substring(LOGIN_PHONE_PAGE.length));
      } else {
        loginPath += '?login_redirect_uri=' + encodeURIComponent(to.fullPath);
      }
      next({
        path: loginPath,
      });
    }
  } else {
    if (to.name === LOGIN_PAGE_CHUNK_NAME && hasLogin) {
      if (getVendorId(to)) {
        sendEventTracker(to, store);
        await sendtrackingVendor(to, store);
      }
      //if (to.query.vendorid) {
      //  await store.dispatch('eventTracker', {
      //    vendorId: to.query.vendorid,
      //  });
      //}
      if (to.query.redirect_uri) {
        let redirect_uri = decodeURIComponent(to.query.redirect_uri);
        if (to.query.isFromEvent) {
          redirect_uri += '&studentId=' + store.state.userInfo.studentId;
        }
        redirect_uri += to.hash;
        window.location.href = redirect_uri;
      } else if (to.query.login_redirect_uri) {
        next({
          path: decodeURIComponent(to.query.login_redirect_uri),
        });
      } else {
        next({
          path: DASHBOARD_PAGE,
        });
      }
    } else {
      if (hasLogin) {
        if (!PAGE_ACCESS_MAP[to.name].access.needsPhone || isPhoneValid) {
          next();
        } else {
          next({
            path: LOGIN_PHONE_PAGE + '?login_redirect_uri=' + encodeURIComponent(to.fullPath),
          });
        }
      } else {
        next();
      }
    }
  }
});
router.afterEach(async (to, from) => {
  // all-courses login mall-order
  await store.dispatch('getVersion');
  const version = cookieGetItem('version');
  if (store.state.version != version) {
    cookieSetItemInfinity('version', store.state.version);
    window.location.reload();
  }
  // console.log(to, from);
  if (!cookieGetItem('visitor_id')) {
    await store.dispatch('getVisitorId');
    const visitorId = store.state.visitorId;
    cookieSetItemInfinity('visitor_id', visitorId);
    cookieSetItemInfinity('is_new_visitor', true);
  } else {
    cookieSetItemInfinity('is_new_visitor', false);
  }

  //const fromDomain = getReferrerHost();
  //const fromUrl = getReferrer();
  if (to && (to.name == 'all-courses' || to.name == 'login' || to.name == 'mall-order')) {
    await sendEventTracker(to, store);
    //await store.dispatch('eventTracker', {
    //  visitorMap: {
    //    fromDomain: fromDomain,
    //    fromEngine: '',
    //    fromKeyword: '',
    //    fromType: '',
    //    fromUrl: fromUrl,
    //    isEntrance: isEntryPage(),
    //    isExit: '',
    //    targetPath: to.path,
    //    targetUrl: getFullUrl(),
    //    vendorId: GetQueryValue('vendorid'),
    //    visitorAgent: getUserAgent(),
    //    visitorBrowser: '',
    //    visitorDeviceId: '',
    //    visitorId: cookieGetItem('visitor_id'),
    //    visitorIp: '',
    //    visitorIsNew: cookieGetItem('is_new_visitor'),
    //    visitorOs: '',
    //    visitorStayTime: '',
    //    visitorStudentId: store.state.userInfo.studentId,
    //  },
    //});
  } else if (to && from && to.name !== 'login' && from.name == 'login') {
    await sendtrackingVendor(from, store);
  }
  $('[data-toggle="popover"]').popover('hide');
  window.sessionStorage.setItem('route_from', from.fullPath);
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

FastClick.attach(document.body);

window.onload = function () {
  window.wgxpath.install();
  window.MQ = window.MathQuill.getInterface(2);
  //window.addEventListener("contextmenu", (t) => {
  //  t.preventDefault()
  //})
  window.ClassicEditor.defaultConfig.toolbar.items = [
    'fontSize',
    'bold',
    'Italic',
    'Underline',
    'alignment:left',
    'alignment:center',
    'alignment:right',
    'alignment:justify',
    //'specialCharacters',
    //'mathLive',
    'indent',
    'outdent',
    'undo',
    'redo',
  ];
};

window.setPzTest = (isDebug) => {
  store.commit(SET_IS_DEBUG, isDebug);
  setLocalStorageItem('isDebug', isDebug);
};

window.globalThis = null;


// 针对catcatch插件《更多功能》- 《视频录制》的检测代码
// 《视频录制》是用video标签创建一个mediastream再使用mediarecoder api录制的，一般针对一些加密的视频
if (!window.CatCatchI18n) { //还没打开录制
  // CatCatchI18n 这个是插件多语言设置的对象，在点击录制时会定义 
  // 原理是提前定义这个对象，并且设置为不可写，一旦插件定义这个对象就会无效，访问里面的属性就会报错，插件就无法继续执行
  Object.defineProperty(window, 'CatCatchI18n', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: "static",
  });
} else { // 已经打开录制面板
  // 这个可以考虑做禁止提示并且不要加载播放器
  console.log('插件在页面启动前已经打开了 《更多功能》- 《视频录制》 的面板')
  // 如果要继续播放可以考虑后面的代码,直接移除面板，如果做了提示可以不用执行以下代码
  var $html = document.getElementsByTagName('html')[0];
  // 这个是弹窗的dom，有可能能会误判，获取到的不是插件的dom，要根据实际页面处理
  var $catCatchDom = $html.children[$html.children.length - 1];
  // 通常HTML最后一个dom是body，需要判断一下
  if (document.body !== $catCatchDom) {
    // 移除
    $html.removeChild($catCatchDom);
  }
  var $catCatchDom2 = document.body.previousElementSibling;
  // 有时候这个插件会把面板加到body前面，因为可能body还没有生成
  if ($catCatchDom2 !== document.head) {
    // 移除
    $html.removeChild($catCatchDom2);
  }
  // 重新定义这个属性，防止二次打开
  Object.defineProperty(window, 'CatCatchI18n', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: "static",
  });
}

